import ActionButtons from './ActionButtons';
import { actionButtonsComiteeName } from './ActionButtons/actionButtonsArray';

function EuAndPubControlDecisions({ encyclopediaUnit = false, committee, step, offerId }) {
  return (
    <ActionButtons
      buttonType={actionButtonsComiteeName.euAndPubControlDecisions}
      encyclopediaUnit={encyclopediaUnit}
      committee={committee}
      step={step}
      offerId={offerId}
    />
  );
}
export default EuAndPubControlDecisions;
